import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Wrapper from './HomePageFooterSidebar.styles';

function HomePageFooterSidebar({ children = null }) {
  return <Wrapper>{children}</Wrapper>;
}

HomePageFooterSidebar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node]),
};

export default memo(HomePageFooterSidebar);
